import React from "react";

/**
 * Shown instead of the app when a setting it cannot run without is absent.
 *
 * Two audiences at once, hence two registers. The sentence is for whoever opened the page and
 * deserves to know it is not their fault; the list below is for whoever has to fix it, and stays
 * untranslated because variable names are variable names. Deliberately free of i18n, router and
 * context — this renders before any of them are trusted to work.
 */
const COPY: Record<string, string> = {
	ru: "Сайт не настроен и не может запуститься. Мы уже знаем об этом.",
	uk: "Сайт не налаштований і не може запуститися. Ми вже знаємо про це.",
	en: "The site is misconfigured and cannot start. We are aware of it.",
};

const localeLine = (): string => {
	const language = (navigator.language || "en").slice(0, 2).toLowerCase();
	return COPY[language] || COPY.en;
};

const EnvContractScreen = ({ missing }: { missing: string[] }) => (
	<div
		role="alert"
		style={{
			minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			gap: "18px",
			padding: "24px",
			textAlign: "center",
			fontFamily: "system-ui, sans-serif",
			color: "#1e1e1e",
			background: "#f5f6fa",
		}}
	>
		<p style={{ margin: 0, fontSize: "16px", maxWidth: "460px" }}>{localeLine()}</p>
		<pre
			style={{
				margin: 0,
				padding: "12px 16px",
				borderRadius: "8px",
				background: "#ffffff",
				border: "1px solid #e0e0e0",
				fontSize: "13px",
				textAlign: "left",
				color: "#767586",
			}}
		>
			{`Missing build settings:\n${missing.map(name => `  ${name}`).join("\n")}`}
		</pre>
	</div>
);

export default EnvContractScreen;
